import React from 'react'
import classNames from 'classnames'
import styles from './styles.module.scss'

type BylineProps = {
  classes: string
  text: string
  colour?: string
}

function Byline({ classes, text, colour }: BylineProps) {
  return (
    <p
      className={`${styles.byline} ${classNames(classes)}`}
      style={{ color: colour }}
    >
      {text}
    </p>
  )
}

export default Byline
